import React from 'react';
import { Star } from 'lucide-react';
import { TOOLS } from '../data/siteData';
import useReveal from '../hooks/useReveal';

export default function ToolsMarquee() {
  const headRef = useReveal();
  const doubled = [...TOOLS, ...TOOLS];

  return (
    <section className="section tools-section" id="tools" data-testid="tools-section">
      <div className="section-inner">
        <div className="section-head reveal" ref={headRef}>
          <span className="section-eyebrow">// ONBOARD TOOLKIT</span>
          <h2 className="section-title">
            POWERED BY THE <span className="text-pink">BEST TECH</span>
          </h2>
        </div>
      </div>

      <div className="marquee" data-testid="tools-marquee">
        <div className="marquee-track">
          {doubled.map((tool, i) => (
            <span className="marquee-item" key={`${tool}-${i}`}>
              <Star size={12} className="marquee-star" />
              {tool}
            </span>
          ))}
        </div>
      </div>
      <div className="marquee marquee-reverse" aria-hidden="true">
        <div className="marquee-track">
          {doubled.reverse().map((tool, i) => (
            <span className="marquee-item marquee-item-outline" key={`${tool}-r-${i}`}>
              <Star size={12} className="marquee-star" />
              {tool}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
